<div class="update-available-dialog">
  <div class="update-available-dialog__title">Update Available</div>
  <div class="update-available-dialog__body">
    A new version of Spotlight is available. Refresh the page to get the latest updates.
  </div>
  <div mat-dialog-actions class="update-available-dialog__actions">
    <button mat-button (click)="refresh()" class="update-available-dialog__refresh-button">Refresh Now</button>
  </div>
</div>
